// src/admin/AdminLayout.js
import React from "react";
import { Outlet } from "react-router-dom";
import { AdminLanguageProvider } from "./context/AdminLanguageContext";

function AdminLayout() {
  return (
    <AdminLanguageProvider>
      <div
        id="admin-root"
        className="flex min-h-screen w-full bg-gray-100 overflow-hidden"
        dir="ltr"
      >
        {/* MAIN CONTENT WRAPPER */}
        <div className="flex-1 min-w-0">
          <Outlet />
        </div>
      </div>
    </AdminLanguageProvider>
  );
}

export default AdminLayout;
